import { COLORS } from "@app/constants";
import styled from "styled-components";

export const TradingAlertSettingSection = styled.div``;
export const TradingAlertContainer = styled.div`
  display: flex;
  border-radius: 5px;
  flex-direction: column;
  width: 100%;
  height: 600px;
  background-color: ${(p) => p.theme.COLORS.drawerBgColor};
  margin-top: 20px;
  padding: 10px;
`;

export const ProfileTradingViewAlertSection = styled.div`
  width: 100%;
  height: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-block: 24px;
  padding-inline: 32px;
  border-radius: 15px;
  background-color: ${COLORS.white};
`;
export const ProfileTradingAlertHeaderSection = styled.div`
  height: 76px;
  width: 100%;
  padding-block: 24px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;
